
import TransactionsList from "../../components/TransactionsList/TransactionsList";
import ButtonAddTransaction from "../../components/ButtonAddTransaction/ButtonAddTransaction.jsx"; 


const HomePage = () => {

  
  return (
    <div>
      <TransactionsList />
      <ButtonAddTransaction />
    </div>
  );
};

export default HomePage;